import type { CopywritingCampaign } from "../../../../../pages/ListEditCopywriting/ListEditCopywriting";

/**
 * Which campaign tag to render for a lead, derived from its resolved campaign config.
 *
 * `selectedCampaignConfig` is computed by Lead's `useMemo`, which already resolves the
 * campaign in priority order (prospect custom config → explicit campaignId → language
 * default → isDefault default). Its three outcomes map one-to-one to a tag state:
 *
 * - `undefined` → the list has no campaign config at all → "no-campaign-created".
 * - a campaign object → a campaign resolved (explicit assignment OR a default/language
 *   campaign that will be used) → "pre-assigned".
 * - `null` → campaigns exist but none resolves for this lead → "not-pre-assigned".
 */
export type CampaignTagState = "no-campaign-created" | "pre-assigned" | "not-pre-assigned";

export const getCampaignTagState = (
	selectedCampaignConfig: CopywritingCampaign | null | undefined
): CampaignTagState => {
	if (selectedCampaignConfig === undefined) {
		return "no-campaign-created";
	}

	if (selectedCampaignConfig) {
		return "pre-assigned";
	}

	return "not-pre-assigned";
};
